import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import EditIcon from "@mui/icons-material/Edit";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import {
  Avatar,
  Grid,
  Drawer,
  Select,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  FormLabel,
  RadioGroup,
  Radio,
  DialogActions,
  Stack,
  Popover,
  TextField,
  Container,
  Modal,
  
} from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";

import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import TaskIcon from "@mui/icons-material/Task";
import InternData2 from "./InternData";
import InternStdDetail from "./InternStdDetail";
import PersonIcon from "@mui/icons-material/Person";
import { updateStudentSupervisor } from "../api/crud";
import { useDispatch, useSelector } from "react-redux";
import { updateSnackbar } from "../redux/action/dataAction";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import CancelIcon from "@mui/icons-material/Cancel";
import { blue, pink } from "@mui/material/colors";
import Chip from "@mui/material/Chip";
import {
  convertDateToString,
  dateDiff,
  timeRemain,
  timeSince,
} from "../utils/function";

import ReactExport from "react-data-export";
import FiberManualRecordOutlinedIcon from "@mui/icons-material/FiberManualRecordOutlined";
import Divider from "@mui/material/Divider";
import {
  GrDocumentPdf,
  GrDocumentText,
  GrLocation,
  GrFormClose,
  GrCopy,
} from "react-icons/gr";
import { MdExpandMore } from "react-icons/md";
import { SiGooglemaps } from "react-icons/si";
import { FcInfo } from "react-icons/fc";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import InfoIcon from "@mui/icons-material/Info";
import MapIcon from "@mui/icons-material/Map";
import { Assignment, Padding } from "@mui/icons-material";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { current } from "@reduxjs/toolkit";

import AddIcon from '@mui/icons-material/Add';
import { engApi } from "../api/engApi";
import { addAssessmentCompanyByStId } from "../api/crud";
import { useForm as hookForm } from "react-hook-form";
import { addAssessmentCompanyCoopByStId, addAssessmentReportCoopByStId } from "../api/crud";
import BulkInputModalCoop from "./BulkInputModalCoop";






const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;






function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
    tableData,
    activeFilter,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  
  const [copySuccess, setCopySuccess] = useState('');

// Inside EnhancedTableHead component
const handleCopy = async (headCell, tableData) => {
  try {
    let copyText = '';
    let validRowCount = 0;
    
    const columnKey = headCell.id;
    
    // Special handling for name column - copy student names (filtered data)
    if (columnKey === 'name' || headCell.enableCopy) {
      // Prefix header with current filter name if available
      const filterLabelMap = {
        projectDetail: 'ยังไม่ได้แจ้งที่ตั้ง',
        logbook: 'Logbook ยังไม่ครบ',
        visit: 'อ.นิเทศยังไม่ได้ประเมิน',
        present: 'นำเสนอยังไม่ได้ประเมิน',
        supervisor: 'พี่เลี้ยงยังไม่ได้ประเมิน',
        report: 'รายงานยังไม่ได้ประเมิน',
      };

      if (activeFilter && filterLabelMap[activeFilter]) {
        copyText += `รายชื่อนิสิต (${filterLabelMap[activeFilter]})\n`;
      } else {
        copyText += `รายชื่อนิสิต\n`;
      }

      // tableData already contains filtered data from the table
      tableData.forEach(row => {
        if (row.st_id && row.name) {
          const studentId = row.st_id?.toString().padStart(8, '0');
          copyText += `${studentId}\t${row.name}\n`;
          validRowCount++;
        }
      });
      
      if (validRowCount > 0) {
        await navigator.clipboard.writeText(copyText);
        setCopySuccess(`✓ คัดลอก ${validRowCount} รายชื่อนิสิต`);
      } else {
        setCopySuccess('ไม่มีข้อมูลให้คัดลอก');
      }
      setTimeout(() => setCopySuccess(''), 2000);
      return;
    }
    
    // Map header to the correct field names in the data based on headcells
    const fieldMap = {
      'intern_location': 'internDetailMark',
      'logbook': 'logbookscore',
      'assessment_visit': 'totalAssignment_visit',
      'assessment_present': 'totalAssignment_present',
      'assessment_supervisor': 'assessment_company_total'
    };

    const labelMap = {
      'intern_location': 'Location Score',
      'logbook': 'Logbook Score',
      'assessment_visit': 'Visit Score',
      'assessment_present': 'Presentation Score',
      'assessment_supervisor': 'Supervisor Score',
      'total': 'Total Score'
    };
    
    // Add data rows without header
    tableData.forEach(row => {
      let value;
      
      // Special handling for total column
      if (columnKey === 'total') {
        // Calculate supervisor score with percentage
        const supervisor_score = row.assessment_company?.total_score 
          ? (parseFloat(row.assessment_company.total_score) / parseFloat(row.assessment_company.max_score || 200)) * 40  // Default 40% if percentages not available
          : 0;
        // Calculate total from all scores
        value = [
          row.internDetailMark || 0,
          row.logbookscore || 0,
          row.totalAssignment_visit || 0,
          row.totalAssignment_present || 0,
          supervisor_score
        ].reduce((sum, val) => sum + (Number(val) || 0), 0);
      } else if (columnKey === 'assessment_supervisor') {
        // Calculate supervisor score with percentage for copy
        value = row.assessment_company?.total_score 
          ? (parseFloat(row.assessment_company.total_score) / parseFloat(row.assessment_company.max_score || 200)) * 40
          : 0;
      } else {
        // For other columns, use the field mapping
        const mappedKey = fieldMap[columnKey] || columnKey;
        value = row[mappedKey];
      }

      // Only process and add to copyText if value exists and is not 0
      if (value && value !== 0) {
        const studentId = row.st_id?.toString().padStart(8, '0');
        
        // Format number
        if (typeof value === 'number') {
          value = value < 10 ? value.toFixed(2) : value.toFixed(1);
        }
        
        copyText += `${studentId}\t${value}\n`;
        validRowCount++;
      }
    });

    // Only proceed with copy if there's data to copy
    if (validRowCount > 0) {
      await navigator.clipboard.writeText(copyText);
      setCopySuccess(`✓ Copied ${validRowCount} rows of ${labelMap[columnKey] || 'scores'}`);
    } else {
      setCopySuccess('No data to copy');
    }
    
    setTimeout(() => setCopySuccess(''), 2000);
  } catch (err) {
    console.error('Failed to copy:', err);
    setCopySuccess('❌ Copy failed - Please try again');
    setTimeout(() => setCopySuccess(''), 2000);
  }
};

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell,index) => (
          <TableCell
            key={headCell.id}
            // align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{border: '1px solid #ccc' , textAlign: 'center', backgroundColor: '#687a8a',
              fontWeight: 'bold', color: 'white', padding: '5px'

            }}
          >
            {index <4  && index > 0 ? (
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              sx={{ whiteSpace: "nowrap" }}
            >
              <Box display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                {headCell.label}
                {headCell.enableCopy && (
                  <Tooltip
                    title={
                      <div style={{ fontSize: '12px', padding: '5px' }}>
                        {copySuccess || 'คัดลอกรายชื่อนิสิต'}
                      </div>
                    }
                    placement="top"
                    arrow
                  >
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent sort when clicking copy
                        handleCopy(headCell, tableData);
                      }}
                      sx={{
                        padding: '2px',
                        fontSize: '12px',
                        color: 'white',
                        '& svg': {
                          filter: 'brightness(0) invert(1)',
                          fontSize: '14px',
                        },
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        },
                      }}
                    >
                      <GrCopy />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>) : (
                <Box justifyItems={'center'}  >

                  {headCell.label}
                <br />
                {index !== 0 && ( 
                    <Tooltip
                      title={
                        <div style={{ fontSize: '12px', padding: '5px' }}>
                          {copySuccess || (
                            <>
                              Click to copy student IDs with {headCell.label}
                              <br />
                              <small style={{ opacity: 0.8 }}>
                                Format: StudentID [tab] Score
                              </small>
                            </>
                          )}
                        </div>
                      }
                      placement="top"
                      arrow
                    >
                      <IconButton
                        onClick={() => handleCopy(headCell, tableData)}
                        sx={{
                          fontWeight: 'bold',
                          fontSize: '12px',
                          color: 'white',
                          '& svg': {
                            filter: 'brightness(0) invert(1)',
                          },
                          '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                          },
                        }}
                      >
                        <GrCopy />
                      </IconButton>
                    </Tooltip>
                  )}
              </Box>
            )}



          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected, excelDataSet, searchCompnent, textActive, percentages, onBulkInput, statistics, activeFilter, onChipClick } = props;
  const totalPercentage = Object.values(percentages).reduce((acc, curr) => acc + Number(curr), 0);

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
        display: "block",
        py: 1,
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={statistics ? 1 : 0}>
        <Box display="flex" alignItems="center" gap={2}>
          {numSelected > 0 ? (
            <Typography color="inherit" variant="subtitle1" component="div">
              {numSelected} selected
            </Typography>
          ) : (
            <Typography variant="h6" id="tableTitle" component="div">
              รายชื่อนิสิต {textActive}
              {activeFilter ? (
                <span style={{ 
                  fontSize: '14px', 
                  fontWeight: 400, 
                  color: '#4a90e2',
                  marginLeft: '8px'
                }}>
                  (
                  {activeFilter === 'projectDetail' ? 'รายละเอียดโครงงานยังไม่ครบ' :
                    activeFilter === 'logbook' ? 'Logbook ยังไม่ครบ' :
                    activeFilter === 'visit' ? 'การนิเทศยังไม่ได้ประเมิน' :
                    activeFilter === 'present' ? 'การนำเสนอยังไม่ได้ประเมิน' :
                    activeFilter === 'supervisor' ? 'พี่เลี้ยงยังไม่ได้ประเมิน' :
                    activeFilter === 'report' ? 'เล่มรายงานยังไม่ได้ประเมิน' : ''}
                  )
                </span>
              ) : null}
            </Typography>
          )}

          <ExcelFile
            element={
              <Tooltip title="Export">
                <IconButton>
                  <SimCardDownloadIcon label="export" sx={{ height: 20 }} />
                </IconButton>
              </Tooltip>
            }
            filename="CWIE ENGBUU"
          >
            <ExcelSheet data={excelDataSet} name="internship">
              <ExcelColumn label="Request Id" value="req_id" />
              <ExcelColumn label="รหัสนิสิต" value="st_id" />
              <ExcelColumn label="ชื่อ - สกุล" value="name" />
              <ExcelColumn label="สาขาวิชา" value="branch" />
              <ExcelColumn label="สถานประกอบการ" value="company" />
              <ExcelColumn label={`แจ้งที่ตั้ง (${percentages?.intern_location}%)`} value="internDetailMark" />
              <ExcelColumn label={`Logbook (${percentages?.logbook}%)`} value="logbookscore" />
              <ExcelColumn label={`อ.นิเทศ (${percentages?.assessment_visit}%)`} value="totalAssignment_visit" />
              <ExcelColumn label={`นำเสนอ (${percentages?.assessment_present}%)`} value="totalAssignment_present" />
              <ExcelColumn label={`พี่เลี้ยง (${percentages?.assessment_supervisor}%)`} value="assessment_company" />
              <ExcelColumn label={`รายงาน (${percentages?.assessment_report}%)`} value="assessment_report" />
             
              <ExcelColumn label={`คะแนนรวม (${totalPercentage}%)`} value="total" />
              

              
              
           
            </ExcelSheet>
          </ExcelFile>

          {/* Bulk Input Button for Company Assessment */}
          <Tooltip title="เพิ่มคะแนนพี่เลี้ยงแบบกลุ่ม">
            <IconButton
              onClick={() => onBulkInput && onBulkInput()}
              sx={{
                backgroundColor: 'rgba(76, 175, 80, 0.1)',
                color: '#4caf50',
                '&:hover': {
                  backgroundColor: 'rgba(76, 175, 80, 0.2)',
                },
                marginLeft: 1
              }}
            >
              <AddIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        </Box>

        <Box>{searchCompnent}</Box>
      </Box>
      
      {/* Statistics Chips - Second Row */}
      {statistics && (
        <Box display="flex" gap={1} alignItems="center" flexWrap="wrap" mt={1}>
          <Chip 
            label={`� รายละเอียดโครงงาน: ${statistics.projectDetail.count}/${statistics.projectDetail.total} (${statistics.projectDetail.percentage}%)`}
            onClick={() => onChipClick && onChipClick('projectDetail')}
            size="small"
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              backgroundColor: activeFilter === 'projectDetail' ? '#1976d2' : '#e3f2fd',
              color: activeFilter === 'projectDetail' ? 'white' : '#1976d2',
              border: `1px solid ${activeFilter === 'projectDetail' ? '#1565c0' : '#90caf9'}`,
              cursor: 'pointer',
              '&:hover': { 
                backgroundColor: activeFilter === 'projectDetail' ? '#1565c0' : '#bbdefb',
              }
            }}
          />
          <Chip 
            label={`📓 Logbook: ${statistics.logbook.count}/${statistics.logbook.total} (${statistics.logbook.percentage}%)`}
            onClick={() => onChipClick && onChipClick('logbook')}
            size="small"
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              backgroundColor: activeFilter === 'logbook' ? '#7b1fa2' : '#f3e5f5',
              color: activeFilter === 'logbook' ? 'white' : '#7b1fa2',
              border: `1px solid ${activeFilter === 'logbook' ? '#6a1b9a' : '#ce93d8'}`,
              cursor: 'pointer',
              '&:hover': { 
                backgroundColor: activeFilter === 'logbook' ? '#6a1b9a' : '#e1bee7',
              }
            }}
          />
          <Chip 
            label={`🧳 การนิเทศ: ${statistics.visit.count}/${statistics.visit.total} (${statistics.visit.percentage}%)`}
            onClick={() => onChipClick && onChipClick('visit')}
            size="small"
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              backgroundColor: activeFilter === 'visit' ? '#2e7d32' : '#e8f5e9',
              color: activeFilter === 'visit' ? 'white' : '#2e7d32',
              border: `1px solid ${activeFilter === 'visit' ? '#1b5e20' : '#81c784'}`,
              cursor: 'pointer',
              '&:hover': { 
                backgroundColor: activeFilter === 'visit' ? '#1b5e20' : '#c8e6c9',
              }
            }}
          />
          <Chip 
            label={`📊 การนำเสนอ: ${statistics.present.count}/${statistics.present.total} (${statistics.present.percentage}%)`}
            onClick={() => onChipClick && onChipClick('present')}
            size="small"
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              backgroundColor: activeFilter === 'present' ? '#e65100' : '#fff3e0',
              color: activeFilter === 'present' ? 'white' : '#e65100',
              border: `1px solid ${activeFilter === 'present' ? '#d84315' : '#ffb74d'}`,
              cursor: 'pointer',
              '&:hover': { 
                backgroundColor: activeFilter === 'present' ? '#d84315' : '#ffe0b2',
              }
            }}
          />
          <Chip 
            label={`🧑‍💼 พี่เลี้ยง: ${statistics.supervisor.count}/${statistics.supervisor.total} (${statistics.supervisor.percentage}%)`}
            onClick={() => onChipClick && onChipClick('supervisor')}
            size="small"
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              backgroundColor: activeFilter === 'supervisor' ? '#c2185b' : '#fce4ec',
              color: activeFilter === 'supervisor' ? 'white' : '#c2185b',
              border: `1px solid ${activeFilter === 'supervisor' ? '#ad1457' : '#f48fb1'}`,
              cursor: 'pointer',
              '&:hover': { 
                backgroundColor: activeFilter === 'supervisor' ? '#ad1457' : '#f8bbd0',
              }
            }}
          />
          <Chip 
            label={`📖 เล่มรายงาน: ${statistics.report.count}/${statistics.report.total} (${statistics.report.percentage}%)`}
            onClick={() => onChipClick && onChipClick('report')}
            size="small"
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              backgroundColor: activeFilter === 'report' ? '#f57f17' : '#fff9c4',
              color: activeFilter === 'report' ? 'white' : '#f57f17',
              border: `1px solid ${activeFilter === 'report' ? '#f57c00' : '#fdd835'}`,
              cursor: 'pointer',
              '&:hover': { 
                backgroundColor: activeFilter === 'report' ? '#f57c00' : '#fff59d',
              }
            }}
          />
        </Box>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function InternRequestTable({
  tableData = [],
  tableColumn = [],
  allStaff = [],
  excelDataSet = [],
  percentages = [],
  textActive,
  onRefreshData,
  statistics,
  activeFilter,
  onChipClick,
}) {
  const profile = useSelector((state) => state.profileReducer.profile);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width:767px)');
  const { handleSubmit, register} = hookForm;

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [studentSelected, setStudentSelected] = useState(null);
  const [studentSupervisorSelected, setStudentSupervisorSelected] =
    useState(null);
  const [supervisorSelected, setSupervisorSelected] = useState(null);
  const [supervisorRemoveSelected, setSupervisorRemoveSelected] =
    useState(null);

  const [supervisorSelfAssign, setSupervisorSelfAssign] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const rows = tableData;
  const [rowsFilter, setRowsFilter] = useState([]);

  const headCells = tableColumn;

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);




  const handleOpenPopover = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowData(rowData);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
    setSelectedRowData(null); // Clear selected row data
  };

  const [reportAnchorEl, setReportAnchorEl] = useState(null);
  const [selectedReportData, setSelectedReportData] = useState(null);
  
  const handleOpenReportPopover = (event, rowData) => {
    setReportAnchorEl(event.currentTarget);
    setSelectedReportData(rowData);
  };

  const handleCloseReportPopover = () => {
    setReportAnchorEl(null);
    setSelectedReportData(null); // Clear selected report data
  };

  const reportOpen = Boolean(reportAnchorEl);
  const reportId = reportOpen ? 'report-popover' : undefined;

  // Bulk Input Modal states
  const [bulkInputModalOpen, setBulkInputModalOpen] = useState(false);

  const handleBulkInput = () => {
    setBulkInputModalOpen(true);
  };

  const handleCloseBulkModal = () => {
    setBulkInputModalOpen(false);
  };

  const handleBulkInputSuccess = () => {
    if (onRefreshData) {
      onRefreshData();
    }
  };

  


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };



  const intt = () => {
    setRowsFilter(rows);
    setSearchTerm("");
  };

  const [totalScore, setTotalScore] = useState('');
  const [total, setTotal] = useState('200');
  const [total2, setTotal2] = useState('100');

  const [evaluator, setEvaluator] = useState('');
  const [internCharacteristics, setInternCharacteristics] = useState('');
  const [internRecommendations, setInternRecommendations] = useState('');
  const [knowledgeBeforeInternship, setKnowledgeBeforeInternship] = useState('');
  const [evaluationDateTime, setEvaluationDateTime] = useState('');


   // State to control the visibility of the modal
   const [openModal1, setOpenModal1] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);

  const [openModal2, setOpenModal2] = useState(false);
  const [selectedItemId2, setSelectedItemId2] = useState(null);


   const handleOpenModal = (itemId) => {
    setSelectedItemId(itemId);
    setOpenModal1(true);
  };

  const handleCloseModal = () => {
    setTotalScore('');
    setTotal('100');
    setEvaluator('');
    setInternCharacteristics('');
    setInternRecommendations('');
    setKnowledgeBeforeInternship('');
    setEvaluationDateTime('');
    setOpenModal1(false);
    setSelectedItemId(null); // Reset selected item
  };

  
  const handleOpenModal2 = (itemId) => {
    setSelectedItemId2(itemId);
    setOpenModal2(true);
  };

  const handleCloseModal2 = () => {
    setTotalScore('');
    setTotal2('200');
    setEvaluator('');
    setInternRecommendations('');
    setEvaluationDateTime('');
    setOpenModal2(false);
    setSelectedItemId2(null); // Reset selected item
};

  function formatDateToYYYYMMDDHHMMSS(date) {
    const pad = (num) => (num < 10 ? '0' + num : num);
    return date.getFullYear() + '-' +
           pad(date.getMonth() + 1) + '-' +
           pad(date.getDate()) + ' ' +
           pad(date.getHours()) + ':' +
           pad(date.getMinutes()) + ':' +
           pad(date.getSeconds());
  }
  
  const handleSubmit1 = async (event) => {
    event.preventDefault();
    // Handle form submission here
    const formData = {
      req_id: selectedItemId?.row?.req_id,
      totalScore: parseFloat(totalScore)/parseFloat(total)*100,
      evaluator,
      internCharacteristics,
      internRecommendations,
      knowledgeBeforeInternship,
      evaluationDateTime: evaluationDateTime === '' ? formatDateToYYYYMMDDHHMMSS(new Date()) : evaluationDateTime,

    };
  
    try {
      const response =  addAssessmentCompanyCoopByStId(formData);
      //engApi.post("/add-assessment-company", formData);

  
      if (!response) {
        throw new Error('Network response was not ok');
      }
  
      
      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกการประเมินเรียบร้อยแล้ว",
        })
      );



      handleCloseModal(); // ปิด modal หลังจากส่งข้อมูลสำเร็จ

    } catch (error) {
      console.error('There was a problem with your fetch operation:', error);
    }
  };

  const handleSubmit2 = async (event) => {
    event.preventDefault();
    // Handle form submission here
    const formData = {
      req_id: selectedItemId2?.row?.req_id,
      totalScore: parseFloat(totalScore)/parseFloat(total2)*100,
      evaluator,
      internRecommendations,
      evaluationDateTime: evaluationDateTime === '' ? formatDateToYYYYMMDDHHMMSS(new Date()) : evaluationDateTime,
    };

    try {
      const response =  addAssessmentReportCoopByStId(formData);
      //engApi.post("/add-assessment-company", formData);

  
      if (!response) {
        throw new Error('Network response was not ok');
      }
  
      
      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกการประเมินเรียบร้อยแล้ว",
        })
      );



      handleCloseModal2(); // ปิด modal หลังจากส่งข้อมูลสำเร็จ

    } catch (error) {
      console.error('There was a problem with your fetch operation:', error);
    }
  };
  
   


  

  useEffect(() => {
    intt();
  }, [rows]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const onHandleSearch = (ev) => {
    const { value } = ev.target;
    setSearchTerm(value);

    const filtered = rows.filter((row) => {
      // Find supervisor name
      const supervisorName = allStaff.find(staff => staff.id === row.supervisor)?.name || '';
      
      return (
       ( row.req_id.toString().toLowerCase().includes(value.toLowerCase()) ||
        row.st_id.toString().toLowerCase().includes(value.toLowerCase()) ||
        row.name.toLowerCase().includes(value.toLowerCase()) ||
        row.company.toLowerCase().includes(value.toLowerCase()) ||
        row.addressIntern.toLowerCase().includes(value.toLowerCase()) ||
        supervisorName.toLowerCase().includes(value.toLowerCase())) 
      );
    });

    setRowsFilter(filtered);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n?.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const onHandleUpdateSupervisor = async (reqId, supervisorId, updatedby) => {
    //console.log("onHandleUpdateSupervisor");
    try {
      await updateStudentSupervisor(reqId, supervisorId, updatedby);

      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกสำเร็จ",
        })
      );

      setStudentSupervisorSelected(null);
    } catch (err) {
      console.warn(err);
    }
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const displayDialogAdvisor = (
    <Dialog
      open={!!studentSupervisorSelected}
      onClose={() => {
        setStudentSupervisorSelected(null);
        setSupervisorSelected(null);
      }}
    >
      <DialogTitle>เลือกอาจารย์นิเทศ</DialogTitle>
      <DialogContent sx={{ width: "500px" }}>
        <Grid container>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <FormLabel id="supervisor-group-label">อาจารย์นิเทศ</FormLabel>
              <RadioGroup
                onChange={(ev) => setSupervisorSelected(ev.target.value)}
                value={supervisorSelected}
                aria-labelledby="supervisor-group-label"
                // defaultValue="female"
                name="radio-buttons-group"
              >
                {allStaff
                  .filter(
                    (staff) =>
                      staff?.b_id == studentSupervisorSelected?.b_id ||
                      (studentSupervisorSelected?.b_id == 7 && staff?.b_id == 4)
                  )
                  .map((item) => {
                    return (
                      <Box display="flex" justifyContent="space-between">
                        <FormControlLabel
                          value={item.id}
                          control={<Radio />}
                          label={`${item?.name}`}
                        />

                        <Tooltip
                          title={
                            <div>
                              {item.internOwn.map((el, elIndex) => {
                                if(el?.internStudent?.name != null){
                                  const count = count+1;
                                return <div>{el?.internStudent?.name}</div>;
                                }
                              })}
                            </div>
                          }
                          placement="right"
                        >
                          <Button sx={{ color: "black" }}>
                            <HowToRegIcon />{" "}
                            <span>{item.internOwn.length} คน</span>
                          </Button>
                        </Tooltip>
                      </Box>
                    );
                  })}

                <FormControlLabel
                  value=""
                  control={<Radio />}
                  label="ยังไม่เลือก"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Stack direction="row">
          <Button
            disabled={!(supervisorSelected !== null)}
            onClick={() => {
              onHandleUpdateSupervisor(
                studentSupervisorSelected.req_id,
                supervisorSelected,
                profile?.id
              );
            }}
          >
            บันทึก
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );

  const displayDialogDelete = (
    <Dialog
      open={!!supervisorRemoveSelected}
      onClose={() => {
        setSupervisorRemoveSelected(null);
      }}
    >
      <DialogTitle id="alert-dialog-title">ยกเลิกการนิเทศ</DialogTitle>

      <DialogActions>
        <Button
          onClick={() => {
            setSupervisorRemoveSelected(null);
          }}
        >
          กลับ
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            onHandleUpdateSupervisor(
              supervisorRemoveSelected.req_id,
              "",
              profile?.id
            );
          }}
          autoFocus
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );

  const displayDialogAssign = (
    <Dialog
      open={!!supervisorSelfAssign}
      onClose={() => {
        setSupervisorSelfAssign(null);
      }}
    >
      <DialogTitle id="alert-dialog-title">ยืนยันเลือกนิสิต</DialogTitle>

      <DialogActions>
        <Button
          onClick={() => {
            setSupervisorSelfAssign(null);
          }}
        >
          กลับ
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            onHandleUpdateSupervisor(
              supervisorSelfAssign.req_id,
              profile.id,
              profile?.id
            );
          }}
          autoFocus
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );

  

  return (
    <>
      {displayDialogAdvisor}
      {displayDialogDelete}
      {displayDialogAssign}

      <Drawer
        anchor="right"
        open={studentSelected ? true : false}
       
        onClose={() => {
          setStudentSelected(null)
          
        }}
        
      >
        <div
          className="card-body shadow-lg"
          style={{ width: "100vw", maxWidth: "600px" }}
        >
          <div className="row g-0">
            <div className="col-12 mb-4">
              <Box display="flex" justifyContent="flex-end">
             
              <Button
                onClick={() => {
                  setStudentSelected(null);
                }}
                startIcon={<CloseIcon />}
              >
                { isMobile ? 'Close' :''}
              </Button>
              </Box>

              <InternStdDetail 
                internRequestId={studentSelected?.req_id} 
                onRefreshData={onRefreshData}
              />

              <Divider />
              {/* add back button */}
              { isMobile &&(
              <Box display="flex" justifyContent="flex-start">
                <Button
                  onClick={() => {
                    setStudentSelected(null);
                  }}
                  startIcon={<ArrowBackIcon />}
                >
                  { isMobile ? 'BACK' :''}
                </Button>
              </Box>)}

            </div>
            {/* <div className="col-12 ">
              <InternData2 st_id={studentSelected?.st_id} />
            </div> */}
          </div>

          <hr />
          {/* <ActivityLog /> */}
        </div>
      </Drawer>

      
        <Paper sx={{ width: "100%" }}>
          <EnhancedTableToolbar
            numSelected={selected.length}
            excelDataSet={excelDataSet}
            textActive={textActive}
            percentages={percentages}
            onBulkInput={handleBulkInput}
            statistics={statistics}
            activeFilter={activeFilter}
            onChipClick={onChipClick}
            searchCompnent={
              <Stack spacing={1}>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', minWidth: '400px' }}>
                  <TextField
                    size="small"
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon 
                            fontSize="small" 
                            sx={{ color: '#4a90e2' }}
                          />
                        </InputAdornment>
                      ),
                      sx: {
                        backgroundColor: 'rgba(74, 144, 226, 0.05)',
                        borderRadius: '8px',
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'rgba(74, 144, 226, 0.3)',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'rgba(74, 144, 226, 0.5)',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#4a90e2',
                        },
                        '& input': {
                          color: '#333',
                          fontSize: '14px'
                        }
                      }
                    }}
                    InputLabelProps={{
                      sx: {
                        color: '#4a90e2',
                        '&.Mui-focused': {
                          color: '#4a90e2'
                        }
                      }
                    }}
                    value={searchTerm}
                    onChange={onHandleSearch}
                    label="ค้นหานิสิต"
                    placeholder="รหัสนิสิต, ชื่อ, บริษัท..."
                    sx={{ flex: 1, minWidth: '350px' }}
                  />
                  
                  {/* ปุ่มรีเซ็ตการกรอง */}
                  {(searchTerm || activeFilter) && (
                    <Tooltip title="ยกเลิกการกรองทั้งหมด">
                      <IconButton
                        onClick={() => {
                          setSearchTerm('');
                          setRowsFilter(rows); // Reset table data to show all rows
                          onChipClick && onChipClick(null);
                        }}
                        sx={{
                          backgroundColor: 'rgba(244, 67, 54, 0.1)',
                          color: '#f44336',
                          '&:hover': {
                            backgroundColor: 'rgba(244, 67, 54, 0.2)',
                          }
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
                
                {(searchTerm || activeFilter) && (
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#666',
                      fontSize: '12px',
                      fontFamily: 'TH Sarabun New, Arial, sans-serif'
                    }}
                  >
                    🔍 ค้นพบ {rowsFilter.length ?? 0} รายการ
                    {activeFilter && (
                      <Box component="span" sx={{ color: '#4a90e2', marginLeft: '4px' }}>
                        ({
                          activeFilter === 'projectDetail' ? 'แจ้งที่ตั้งยังไม่ได้ประเมิน' :
                          activeFilter === 'logbook' ? 'Logbook ยังไม่มี' :
                          activeFilter === 'visit' ? 'อ.นิเทศยังไม่ได้ประเมิน' :
                          activeFilter === 'present' ? 'รายงานยังไม่ส่ง' :
                          activeFilter === 'supervisor' ? 'พี่เลี้ยงยังไม่ได้ประเมิน' :
                          activeFilter === 'report' ? 'รายงานยังไม่ส่ง' :
                          ''
                        })
                      </Box>
                    )}
                  </Typography>
                )}
              </Stack>
            }
          />
        
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}

          PaperProps={{
            style: { maxWidth: '400px' }, // Set a maximum width for the Popover
          }}
        >
          <Typography sx={{ p: 2, wordWrap: 'break-word' }}>
            {selectedRowData?.assessment_visit?.comment}
          </Typography>
        </Popover>

        <Popover
          id={reportId}
          open={reportOpen}
          anchorEl={reportAnchorEl}
          onClose={handleCloseReportPopover}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          PaperProps={{
            style: { maxWidth: '400px' }, // Adjust as needed
          }}
        >
          <Typography sx={{ p: 2, wordWrap: 'break-word' }}>
            {selectedReportData?.assessment_present?.comment}
          </Typography>
        </Popover>
      
          <TableContainer sx={{
            padding: '20px', boxShadow: '0 0 10px rgba(0,0,0,0.1)'
          }}>
            <Table
              sx={{borderRadius: '10px' }}
              //aria-labelledby="tableTitle"
              //size={dense ? "small" : "medium"}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rowsFilter.length}
                headCells={headCells}
                tableData={rowsFilter}
                activeFilter={activeFilter}
              />
              <TableBody>
                {stableSort(rowsFilter, getComparator(order, orderBy))
                  // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row?.name);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (

                      <TableRow
                        hover
                        // onClick={(event) => handleClick(event, row.name)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.req_id}
                        selected={isItemSelected}
                      >
                        <TableCell sx={{ verticalAlign: "top", border: '1px solid #ccc' , padding: '5px', textAlign: 'center' }}>
                          {index + 1}
                        </TableCell>

                        <TableCell sx={{ verticalAlign: "top", border: '1px solid #ccc' , padding: '5px', textAlign: 'center'}}>
                          {row.req_id}
                        </TableCell>

                        <TableCell sx={{ minWidth: 250, verticalAlign: "top", border: '1px solid #ccc' , padding: '5px'}}>
                          <Box display="flex" gap={1}>
                            <Avatar
                              onClick={() => setStudentSelected(row)}
                              role="button"
                              alt="profile"
                              sx={{ width: 30, height: 30 }}
                              src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${row.st_id}`}
                            />
                            <Box>
                              <Box sx={{ fontWeight: "bold", fontSize: 12 }}>
                                {row.st_id}
                              </Box>
                              <Box sx={{ fontWeight: "bold", fontSize: 13 }}>
                                {row?.name?.split(",")[0]}
                              </Box>

                              
                             
{/* 
                              <Box>
                                <span className="badge bg-primary">
                                  {row?.name?.split(",")[1]}
                                </span>
                                <Tooltip title="ข้อมูลนิสิต">
                                  <IconButton
                                    sx={{ height: 30, width: 30 }}
                                    onClick={() => setStudentSelected(row)}
                                  >
                                    <FcInfo />
                                  </IconButton>
                                </Tooltip>
                              </Box> */}
                              
                            </Box>
                          </Box>
                        </TableCell>

                       
                        <TableCell align="left" sx={{  border: '1px solid #ccc' , padding: '10px', textAlign: 'start'
                         }}>
                          <Box>
                          
                                
                             { row.supervisor && (
                                <Tooltip
                                  title={
                                    row.supervisor &&
                                    allStaff.length &&
                                    allStaff?.find(
                                      (staff) => staff.id === row.supervisor
                                    )?.name
                                  }
                                >
                                  <Chip
                                    label={
                                      row.supervisor &&
                                      allStaff.length &&
                                      allStaff
                                        ?.find(
                                          (staff) => staff.id === row.supervisor
                                        )
                                        ?.name.split(" ")[0]
                                    }
                                    size="small"
                                    color="default"
                                    variant='filled'
                                  />
                                </Tooltip>
                              )}
                            

                          
                          </Box>
                        </TableCell>

                   

                        <TableCell sx={{  border: '1px solid #ccc' , padding: '5px', textAlign: 'center'
                         }}> 
                            {parseFloat(row?.internDetailMark) != 0 ? (parseFloat(row?.internDetailMark)||0).toFixed(1) : "-"}
                            
                        </TableCell>

                        <TableCell sx={{  border: '1px solid #ccc' , padding: '5px', textAlign: 'center'
                         }}> 
                            {row?.logbookscore != 0 ? (row?.logbookscore.toFixed(1)) : "-"}
                        </TableCell>


                        <TableCell sx={{  border: '1px solid #ccc' , padding: '5px', textAlign: 'center'
                         }}> 
                          <Box>
                          
                          {(row?.totalAssignment_visit|| 0) != 0 ? (
                            <Link 
                              to={`/assessment-visitcoop?req_id=${row?.req_id}`}
                              target="_blank"
                              style={{ 
                                textDecoration: 'none', 
                                color: '#1976d2',
                                fontWeight: 'bold'
                              }}
                            >
                              {row?.totalAssignment_visit.toFixed(1)}
                            </Link>
                          ) : "-"}
                         
                         
                         
                          {isNaN(row?.totalAssignment_visit) ?"":
                               (
                              <IconButton
                                sx={{ height: 30, width: 30 }}
                                onClick={(event) => handleOpenPopover(event, row)}
                                
                                
                              >
                                <FcInfo /> 
                              </IconButton>
                            ) }
                          
                          </Box>
                        
                        
                        
                        
                       
                        </TableCell>

                        <TableCell sx={{ border: '1px solid #ccc', padding: '5px', textAlign: 'center'}}>
                          <Box>
                            {(row?.totalAssignment_present || 0) != 0 ? (
                              <Link 
                                to={`/assessment-presentcoop?req_id=${row?.req_id}`}
                                target="_blank"
                                style={{ 
                                  textDecoration: 'none', 
                                  color: '#1976d2',
                                  fontWeight: 'bold'
                                }}
                              >
                                {row?.totalAssignment_present.toFixed(1)}
                              </Link>
                            ) : "-"}

                            {isNaN(row?.totalAssignment_present) ? "" :
                              (
                                <IconButton
                                  sx={{ height: 30, width: 30 }}
                                  onClick={(event) => handleOpenReportPopover(event, row)}


                                >
                                  <FcInfo />
                                </IconButton>
                              )}
                          </Box>
                        </TableCell>

                        <TableCell sx={{border: '1px solid #ccc', padding: '5px', textAlign: 'center'}}>
                          {(row?.assessment_company?.total_score || 0) != 0 ? (
                            <Link 
                              to={`/supervisor-evaluation?req_id=${row.req_id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ 
                                textDecoration: 'none',
                                color: '#1976d2',
                                fontWeight: 'bold',
                                cursor: 'pointer'
                              }}
                              onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                              onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                            >
                              {((parseFloat(row?.assessment_company.total_score) / parseFloat(row?.assessment_company.max_score || 200)) * parseFloat(percentages?.assessment_supervisor || 40)).toFixed(1)}
                            </Link>
                          ) : '-'}
                        </TableCell>

                        <TableCell sx={{border: '1px solid #ccc', padding: '5px', textAlign: 'center'}}>
                          {(row?.assessment_report_obj?.total_score || 0) != 0 ? (
                            <Link 
                              to={`/coop-report-evaluation?req_id=${row?.req_id}`}
                              target="_blank"
                              style={{ 
                                textDecoration: 'none', 
                                color: '#1976d2',
                                fontWeight: 'bold'
                              }}
                            >
                              {((parseFloat(row?.assessment_report_obj.total_score) / parseFloat(row?.assessment_report_obj.max_score || 100)) * parseFloat(percentages?.assessment_report || 10)).toFixed(1)}
                            </Link>
                          ) : '-'}
                        </TableCell>

                        

                        <TableCell sx={{ backgroundColor: '#eceff1' , border: '1px solid #ccc', padding: '5px', textAlign: 'center'}}>
                          <Box sx={{ fontWeight: 'bold' }}>
                            {
                              (() => {
                                const supervisor_score = row?.assessment_company?.total_score 
                                  ? (parseFloat(row.assessment_company.total_score) / parseFloat(row.assessment_company.max_score || 200)) * parseFloat(percentages?.assessment_supervisor || 40)
                                  : 0;
                                const report_score = row?.assessment_report_obj?.total_score 
                                  ? (parseFloat(row.assessment_report_obj.total_score) / parseFloat(row.assessment_report_obj.max_score || 100)) * parseFloat(percentages?.assessment_report || 10)
                                  : 0;
                                const totalScore = [
                                  row?.logbookscore, 
                                  row?.internDetailMark, 
                                  row?.totalAssignment_visit, 
                                  row?.totalAssignment_present, 
                                  supervisor_score, 
                                  report_score
                                ]
                                  .map(parseFloat)
                                  .filter(value => !isNaN(value))
                                  .reduce((acc, value) => acc + value, 0);

                                // Determine color based on score
                                let color = '#000'; // default black
                                if (totalScore > 80) {
                                  color = '#2e7d32'; // green
                                } else if (totalScore < 50) {
                                  color = '#d32f2f'; // red
                                }

                                return (
                                  <span style={{ color: color }}>
                                    {totalScore.toFixed(1)}
                                  </span>
                                );
                              })()
                            }
                           </Box>
                        </TableCell>

                      </TableRow>
                    );
                  })}

                {/* {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )} */}

              
                  
              </TableBody>

                

            </Table>
          </TableContainer>
          
          
        </Paper>

      <Modal
        open={openModal1}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400, // Adjust the width as needed
            bgcolor: 'rgba(255, 255, 255, 1)', // Making the background semi-transparent
            boxShadow: 80,
            p: 3,
            outline: 'none' // Removes the focus outline for a cleaner look
          }}
        >
          <Typography sx={{
            fontSize: 20,
            fontWeight: 'bold',
            textAlign: 'left',
            paddingBottom: '10px'

          }}>
            <Box sx={{ fontWeight: 'bold' }}>
              แบบประเมินนิสิตสหกิจศึกษาจากพี่เลี้ยง
            </Box>
            <Typography sx={{
              fontSize: 15,
              fontWeight: 'bold',
              textAlign: 'left',

            }}>
              <Typography sx={{
                fontSize: 15,
                fontWeight: 'bold',
                textAlign: 'left',
              }}>
                ReqID:
                {selectedItemId?.row?.req_id}
              </Typography>
              {selectedItemId?.row?.name.split(",")[0]}
            </Typography>
            <Typography sx={{
              fontSize: 15,
              fontWeight: 'bold',
              textAlign: 'left',
              paddingBottom: '10px'
            }}>
              {selectedItemId?.row?.name.split(",")[1]}
            </Typography>
            <Typography sx={{
              fontSize: 15,
              fontWeight: 'bold',
              textAlign: 'left',
              paddingBottom: '10px'
            }}>
              {selectedItemId?.row?.company}
            </Typography>
          </Typography>

          <form onSubmit={handleSubmit1} style={{ /* Style your form container */ }}>
            <FormControl fullWidth>
              {/* Form fields */}
              <Grid item xs={2} md={2}>
                <Box>
                  <TextField
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    paddingBottom="20px" label="คะแนนรวมจากพี่เลี้ยง " required onChange={(e) => setTotalScore(e.target.value)} />
                  <TextField
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={200}
                    paddingBottom="20px" label="คะแนนเต็ม " required onChange={(e) => setTotal(e.target.value)} />
                </Box>
              </Grid>

              <TextField paddingBottom="20px" label="ผู้ประเมิน" required onChange={(e) => setEvaluator(e.target.value)} />
              <TextField multiline maxRows={3}
                paddingBottom="20px" label="จุดเด่นของนิสิต/Strength" onChange={(e) => setInternCharacteristics(e.target.value)} />
              <TextField paddingBottom="20px" label="ข้อควรปรับปรุงของนิสิต/Improvement" onChange={(e) => setKnowledgeBeforeInternship(e.target.value)} />

              <TextField paddingBottom="20px" label="ข้อคิดเห็นเพิ่มเติม" onChange={(e) => setInternRecommendations(e.target.value)} />
              <TextField paddingBottom="20px" label="วัน/เวลาประเมิน (รูปแบบ: YYYY-MM-DD 09:00:00)" defaultValue={formatDateToYYYYMMDDHHMMSS(new Date())}
                onChange={(e) => setEvaluationDateTime(e.target.value)

                } />
              {/* Add more fields as needed */}
            </FormControl>
            <Button type="submit">Submit</Button>
            <Button onClick={handleCloseModal}>Close</Button>
          </form>
        </Box>
      </Modal>

      <Modal
        open={openModal2}
        onClose={handleCloseModal2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400, // Adjust the width as needed
            bgcolor: 'rgba(255, 255, 255, 1)', // Making the background semi-transparent
            boxShadow: 80,
            p: 3,
            outline: 'none' // Removes the focus outline for a cleaner look
          }}
        >
          <Typography sx={{
            fontSize: 20,
            fontWeight: 'bold',
            textAlign: 'left',
            paddingBottom: '10px'

          }}>
            <Box sx={{ fontWeight: 'bold' }}>
              แบบประเมิน <br />
              รายงานสหกิจศึกษาจากพี่เลี้ยง
            </Box>
            <Typography sx={{
              fontSize: 15,
              fontWeight: 'bold',
              textAlign: 'left',

            }}>
              <Typography sx={{
                fontSize: 15,
                fontWeight: 'bold',
                textAlign: 'left',
              }}>
                ReqID:
                {selectedItemId2?.row?.req_id}
              </Typography>
              {selectedItemId2?.row?.name.split(",")[0]}
            </Typography>
            <Typography sx={{
              fontSize: 15,
              fontWeight: 'bold',
              textAlign: 'left',
              paddingBottom: '10px'
            }}>
              {selectedItemId2?.row?.name.split(",")[1]}
            </Typography>
            <Typography sx={{
              fontSize: 15,
              fontWeight: 'bold',
              textAlign: 'left',
              paddingBottom: '10px'
            }}>
              {selectedItemId2?.row?.company}
            </Typography>
          </Typography>

          <form onSubmit={handleSubmit2} style={{ /* Style your form container */ }}>
            <FormControl fullWidth>
              {/* Form fields */}
              <Grid item xs={2} md={2}>
                <Box>
                  <TextField
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    paddingBottom="20px" label="คะแนนรวมจากพี่เลี้ยง " required onChange={(e) => setTotalScore(e.target.value)} />
                  <TextField
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={100}
                    paddingBottom="20px" label="คะแนนเต็ม " required onChange={(e) => setTotal2(e.target.value)} />
                </Box>
              </Grid>

              <TextField paddingBottom="20px" label="ผู้ประเมิน" required onChange={(e) => setEvaluator(e.target.value)} />
              <TextField paddingBottom="20px" label="ข้อคิดเห็นเพิ่มเติม" onChange={(e) => setInternRecommendations(e.target.value)} />
              <TextField paddingBottom="20px" label="วัน/เวลาประเมิน (รูปแบบ: YYYY-MM-DD 09:00:00)" defaultValue={formatDateToYYYYMMDDHHMMSS(new Date())}
                onChange={(e) => setEvaluationDateTime(e.target.value)

                } />
              {/* Add more fields as needed */}
            </FormControl>
            <Button type="submit">Submit</Button>
            <Button onClick={handleCloseModal2}>Close</Button>
          </form>
        </Box>
      </Modal>

      {/* Bulk Input Modal for Coop */}
      <BulkInputModalCoop
        open={bulkInputModalOpen}
        onClose={handleCloseBulkModal}
        tableData={rowsFilter}
        onRefresh={handleBulkInputSuccess}
      />
      
      
      
    </>
  );
}
